import React, { Fragment } from 'react';
import spinner from '../../assets/img/1488.gif';

const Spinner = () => (
  <Fragment>
    <img
      src={spinner}
      style={{ width: '100px', margin: '200px auto', display: 'block' }}
      alt="Loading..."
    />
  </Fragment>
);

export default Spinner;
